import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    openMobileFilter,
    triggerPlayerSkillsFilter,
    setPlayerRecomendationKey
} from './../../../actions/FormationActions';
import {

    applyClubBoth,
    applyPrizeBoth

} from './../../../actions/FilterActions';
import config from './../../../config';
import common from '../../../common';
import { transcode } from 'buffer';

class FilterBy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filtersObj: []
        }
    }

    getPriceLable = (id) => {
        var priceLable = ""
        if (id >= 100) {
            priceLable = this.props.trans[config.priceFilterObj[id].label] ? this.props.trans[config.priceFilterObj[id].label] : config.priceFilterObj[id].label;
        } else if (id < 100) {
            priceLable = config.priceFilterObj[id].label ? (this.props.trans.upTo ? this.props.trans.upTo : "upTo") + " " + config.priceFilterObj[id].label + this.props.trans.million : "m"
        } else {
            priceLable = config.priceFilterObj[id].label
        }
        return priceLable;
    }

    updateArray(nextProps) {
        let updatedProps = "";
        if (nextProps) {
            updatedProps = nextProps
        } else {
            updatedProps = this.props;
        }
        let self = this;
        let skillsColl = updatedProps.filtersApplied.skillId.map(function (skill) {
            return {
                name: self.props.trans[skill].toLowerCase(),
                id: skill,
                key: 1
            };
        })

        let teamName = updatedProps.filtersApplied.teamNamesObj.map(function (teamname, index) {
            return {
                name: teamname,
                id: updatedProps.filtersApplied.teamIds[index],
                key: 3
            };
        })

        let playerRecomendation = [];
        if (updatedProps.filtersApplied.playerRecomendation[0] == config.playerRecomendationDefault) {

        } else {
            playerRecomendation = updatedProps.filtersApplied.playerRecomendation.map(function (name) {
                return {
                    name: updatedProps.trans[name] ? updatedProps.trans[name] : name,
                    id: name,
                    key: 4
                };
            })
        }
        let priceFilter = [];
        if (updatedProps.filtersApplied.priceFilterSelected[0] == 100) {

        } else {
            priceFilter = updatedProps.filtersApplied.priceFilterSelected.map(function (priceSelected) {

                return {
                    name: self.getPriceLable(priceSelected),
                    id: config.priceFilterObj[priceSelected].id,
                    key: 2
                }
            })
        }


        this.setState({
            filtersObj: skillsColl.concat(teamName).concat(priceFilter).concat(playerRecomendation),
        })
    }

    removeChip(object) {
        if (object.key == 1) {
            //remove skills
            this.props.triggerPlayerSkillsFilter(object.id);
        } else if (object.key == 2) {
            //remove price
            this.props.applyPrizeBoth(object.id);
        } else if (object.key == 3) {
            //remove club
            var clubObj = {
                TID: object.id,
                OfficialName: object.name
            }
            this.props.removeClub(clubObj)
        } else {
            var playerRecomColl = {
                Key: object.id,
            }
            this.props.setPlayerRecomendationKey(playerRecomColl)
        }
    }


    componentWillReceiveProps(nextProps) {
        //get all filters printed
        this.updateArray(nextProps);

    }

    componentDidMount() {
        this.updateArray();
    }


    render() {
        let trans = this.props.trans;
        return <div className="si-filter-active" style={ this.state.filtersObj.length > 0 ? { "display": "block" } : { "display": "none" } }>
            <div className="si-flexBox si-filter-active-wrp">
                <span className="si-filter-label">{ trans.filterBy ? trans.filterBy : "filter By" }</span>
                <div className="si-filter-active-list si-flexBox">
                    { this.state.filtersObj.map((object, index) => {
                        return <div className="si-filter-list-item" key={ index } name={ object.id } onClick={ (e) => { this.removeChip(object) } }>
                            <span className="si-flexBox" style={ { 'textTransform': 'capitalize' } }>{ object.name }</span>
                        </div>
                    }) }

                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    let playerFilter = state.formationData.playerFilters;
    return {
        trans: state.appData.trans,
        filtersApplied: { ...playerFilter }
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        filterCount: (bool) => dispatch(openMobileFilter(bool)),
        triggerPlayerSkillsFilter: (skill) => dispatch(triggerPlayerSkillsFilter(skill)),
        applyPrizeBoth: (priceId) => dispatch(applyPrizeBoth(priceId)),
        removeClub: (teamId) => dispatch(applyClubBoth(teamId)),
        setPlayerRecomendationKey: (obj) => dispatch(setPlayerRecomendationKey(obj)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterBy);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/FilterBy.js